import {useState, useRef, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useParams, useNavigate, useOutletContext} from 'react-router-dom'
import {DocumentManagmentStore, fetchDocumentUser} from '../../features/dashboard/DocumentManagmentSlice'
import Header from './Header';
import Button from '../form/Button';
import Loading from '../../Loading';
import { ToastContainer, toast } from 'react-toastify';
import Broadcast from './Broadcast';

function DocumentManagment (props) {
    const navigate = useNavigate()
    const url = useOutletContext()
    const {id} = useParams()
    const userId = useRef(id)
    const dispatch = useDispatch()
    let [items, setItems] = useState({})
    let archiveItem = useRef([])
    const [status, setStatus] = useState(false)
    const {users} = useSelector((state) => state.user)
    const {
        loading,
        success,
        message,
        itemList
    } = useSelector((state) => state.DocumentManagment)
    const checkHandler = (event, id) => {

        if(event.target.getAttribute('data-status') === 'true') {
            event.target.setAttribute('data-status', 'false')
        }else if(event.target.getAttribute('data-status') === null) {
            event.target.setAttribute('data-status', true)
        }else {
            event.target.setAttribute('data-status', true)
        }
        
        setItems({...items,[event.target.name] : event.target.getAttribute('data-status')})

    }

    const DocumentManagmentStoreHandler = () => {
        const data = {
            'user_id': id,
            'item': items
        }
        dispatch(DocumentManagmentStore(data))
        setStatus(true)
    }

    const goToUserIndex = () => {
        navigate('/dashboard/user/index', { replace: true })
    }
    
    useEffect(() => {
        const data = {
            'user_id': id,
        }
        dispatch(fetchDocumentUser(data))
        if(success === true && status === true) {
            toast.success(message,{
                position: "top-center",
                autoClose: 600,
              })
            setStatus(false)
        }
        if(loading === true) 
            document.body.style.overflow = "hidden"
        if(loading === false)
            document.body.style.overflow = "auto"  
        return () => {
            items = null
        }
    },[])

    return (
        <>
            { loading ? ( <Loading /> ) : null}
            <Broadcast title={'انتخاب سطح دسترسی سند ها'} />
           
            <div className='row rahpardaznet-cart my-5 print-position'>
                <Header title={'انتخاب سطح دسترسی'} />
                <div className=" row col-12">
                        {
                            (itemList.length > 0) ? (
                                itemList.map((row, key) => 
                                <div key={key} className="col-md-3">
                                    <div key={key} className='d-flex justifycontent-start m-1 rahpardaznet-swich  border bg-light rounded align-items-center form-check form-switch'>
                                        <input 
                                            name={row.id}
                                            type="checkbox"
                                            id={`rule-${++key}`} 
                                            key={`rule-${++key}`}
                                            ref={(element) => { archiveItem.current[row.id] = element }}
                                            data-status={row.DocumentPermission}
                                            defaultChecked={row.DocumentPermission}
                                            className="form-check-input" 
                                            onChange={(e) => checkHandler(e,row.id)} 
                                            role="switch" 
                                        />                                      
                                        <label key={key} className="form-check-label rahpardaznet-swich-title px-3" forHtml="flexSwitchCheckDefault">
                                            <strong>{row.position}</strong>
                                        </label>
                                    </div>
                                </div>
                                )
                            ) : null     
                        }                       
                    </div>
                </div>
           
            <div className="row p-0">
                <div className='col-12 p-0'>
                <Button
                    tab='2'
                    title='برگشت به صفحه کاربران'
                    design="rahpardaznet-button outline"
                    event={goToUserIndex}
                />
                <Button
                    tab='1'
                    title='ثبت دسترسی سند'
                    design="rahpardaznet-button"
                    event={DocumentManagmentStoreHandler}
                />
                </div>
            </div>
        </>
    )
}

export default DocumentManagment;